// eslint-disable-next-line import/no-unresolved
const KeenSlider = window.KeenSlider

class QuickbuyModal extends window.BAO.CustomElement() {
  constructor() {
    super()
    this.slider = null
  }

  setupListeners() {
    super.setupListeners()

    this.listeners.add(this.els.open.element, 'click', this.openModal.bind(this))
    this.listeners.add(this.els.modal.element, 'close', this.onClose)

    this.els.form.elements.forEach((el) => {
      this.listeners.add(el, 'submit', this.closeModal.bind(this))
    })
  }

  openModal() {
    document.body.classList.add('util-SiteOverflowed')

    this.els.modal.element.showModal()

    if (!this?.els?.slides?.element) return

    this.initialiseCarousel()
  }

  closeModal() {
    this.els.modal.element.close()
  }

  onClose() {
    document.body.classList.remove('util-SiteOverflowed')
  }

  initialiseCarousel() {
    this.slider = new KeenSlider(this.els.slides.element, {
      duration: 1000,
      loop: false,
      mode: 'snap',
      slidesPerView: 1,
      slides: '.car-Carousel_Slide',
      spacing: 15,
      slideChanged: instance => {
        if (this.els.next.element) {
          const currentSlide = instance.details().absoluteSlide
          const slidesPerView = instance.details().slidesPerView
          const carouselSize = instance.details().size

          currentSlide === 0
            ? this.els.previous.element.setAttribute('disabled', true)
            : this.els.previous.element.removeAttribute('disabled')

          currentSlide + slidesPerView >= carouselSize
            ? this.els.next.element.setAttribute('disabled', true)
            : this.els.next.element.removeAttribute('disabled')
        }
      },
      created: instance => {
        if (this.nextEl) {
          this.nextEl.addEventListener('click', () => {
            instance.next()
          })
        }

        if (this.previousEl) {
          this.previousEl.addEventListener('click', () => {
            instance.prev()
          })
        }
      },
    })
  }

  get nextEl() {
    return this.els.next && this.els.next.element ? this.els.next.element : null
  }

  get previousEl() {
    return this.els.previous && this.els.previous.element
      ? this.els.previous.element
      : null
  }
}

if (!customElements.get('quickbuy-modal')) {
  customElements.define('quickbuy-modal', QuickbuyModal)
}
